import { type LegacyProductCode } from '@up2stay/up2promo-api-client';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@up2stay/up2promo-ui';

type ResetConfirmPayload = {
  hash: string;
  productId: string;
  productType?: LegacyProductCode;
};

export type ProductsSetupWizardDialogsProps = {
  productsSetupDict: Record<string, string | undefined>;
  resetConfirmPayload: ResetConfirmPayload | null;
  onResetConfirmOpenChange: (open: boolean) => void;
  onResetConfirm: () => void;
  isResetPending: boolean;
  showAbortConfirm: boolean;
  onAbortConfirmOpenChange: (open: boolean) => void;
  onAbortConfirm: () => void;
};

export function ProductsSetupWizardDialogs({
  productsSetupDict,
  resetConfirmPayload,
  onResetConfirmOpenChange,
  onResetConfirm,
  isResetPending,
  showAbortConfirm,
  onAbortConfirmOpenChange,
  onAbortConfirm,
}: ProductsSetupWizardDialogsProps) {
  return (
    <>
      <AlertDialog
        open={!!resetConfirmPayload}
        onOpenChange={onResetConfirmOpenChange}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              {productsSetupDict.alreadyInWorkspaceResetTitle}
            </AlertDialogTitle>
            <AlertDialogDescription>
              {productsSetupDict.alreadyInWorkspaceResetMessage}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{productsSetupDict.cancel}</AlertDialogCancel>
            <Button onClick={onResetConfirm} disabled={isResetPending}>
              {isResetPending
                ? productsSetupDict.resetting
                : productsSetupDict.resetProduct}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog
        open={showAbortConfirm}
        onOpenChange={onAbortConfirmOpenChange}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              {productsSetupDict.abortConfirmTitle}
            </AlertDialogTitle>
            <AlertDialogDescription>
              {productsSetupDict.abortConfirmDescription}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{productsSetupDict.cancel}</AlertDialogCancel>
            <Button onClick={onAbortConfirm}>
              {productsSetupDict.discard}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
